import React from "react";
import "../style/Home.css";
import "../style/ReportCard.css";
import "../style/Bundles.css";
import { Accordion, Button, Card } from "react-bootstrap";
import RowCard from "../Components/RowCard.js";
import DynamicTable from "../Components/DynamicTable.js";
import { formatCurrency } from "../Util/Utils.js";

const BundlesList = ({ props }) => {
  const filteredUserBundleLicensesByCompanyList = props.userBundleLicensesByCompanyLists[0]
    ? props.userBundleLicensesByCompanyLists[0]
        .filter((license) => {
          if (props.isHomeOffice) {
            return props.companyToBusinessUnitMap.get(license.companyName) === props.list.businessUnitName;
          } else {
            return props.companyToBusinessUnitMap.get(license.companyName) === props.businessUnit;
          }
        })
        .sort((a, b) => (a.fullName ?? "").localeCompare(b.fullName ?? ""))
    : [];

  const getTotalPriceOfBundles = () => {
    let totalPrice = 0;

    filteredUserBundleLicensesByCompanyList.forEach((employee) => {
      totalPrice += props.licenseBundlesIdToBundle.get(employee.licenseBundleId).bundlePrice;
    });

    return totalPrice;
  };

  const getTotalPriceOfItaas = () => {
    let totalPrice = 0;

    filteredUserBundleLicensesByCompanyList.forEach((employee) => {
      totalPrice += props.licenseBundlesIdToBundle.get(employee.itaasPackageId).bundlePrice;
    });

    return totalPrice;
  };

  const getTotalPriceOfALaCarte = () => {
    let totalPrice = 0;

    filteredUserBundleLicensesByCompanyList.forEach((employee) => {
      totalPrice += props.licenseBundlesIdToBundle.get(employee.asanaPackageId).bundlePrice;
      totalPrice += props.licenseBundlesIdToBundle.get(employee.copilotPackageId).bundlePrice;
      totalPrice += props.licenseBundlesIdToBundle.get(employee.adobeAcrobatProPackageId).bundlePrice;
      totalPrice += props.licenseBundlesIdToBundle.get(employee.teamsPhonePackageId).bundlePrice;
    });

    return totalPrice;
  };

  const getNumberOfItaasUsers = () => {
    const itaasUsers = filteredUserBundleLicensesByCompanyList.filter(
      (employee) => props.licenseBundlesIdToBundle.get(employee.itaasPackageId).bundleName !== "None"
    );

    return itaasUsers.length;
  };

  const tableColumns = filteredUserBundleLicensesByCompanyList.map((employee) => {
    return (
      <>
        <td className="col-sm-3" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <div>{employee.fullName}</div>
          <div style={{ whiteSpace: "nowrap", color: "gray" }}>{employee.domainName}</div>
        </td>
        {props.licenseBundles.find((bundle) => bundle.bundleId === employee.licenseBundleId) && (
          <td
            className="col-sm-2"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div>{props.licenseBundles.find((bundle) => bundle.bundleId === employee.licenseBundleId).bundleName}</div>
            <div style={{ color: "gray" }}>
              {formatCurrency(props.licenseBundlesIdToBundle.get(employee.licenseBundleId).bundlePrice)}
            </div>
          </td>
        )}
        {
          <td className="col-sm-1">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>{props.licenseBundlesIdToBundle.get(employee.itaasPackageId).bundleName}</div>
              <div style={{ color: "gray" }}>
                {formatCurrency(props.licenseBundlesIdToBundle.get(employee.itaasPackageId).bundlePrice)}
              </div>
            </div>
          </td>
        }
        <td className="col-sm-4">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>{props.getALaCartes(employee)}</div>
            <div style={{ color: "gray" }}>{formatCurrency(props.getALaCartePrice(employee))}</div>
          </div>
        </td>

        <td className="col-sm-2">
          <Button
            type="button"
            className="details-button"
            size="sm"
            onClick={() => {
              props.setSelectedEmployee(employee);
              props.setIsALaCarteModalShowing(true);
            }}
          >
            Details
          </Button>
        </td>
      </>
    );
  });

  const renderHeaderRow = () => {
    return (
      <>
        <td className="col-sm-3 bundles-header-cell text-start">Employee</td>
        <td className="col-sm-2 bundles-header-cell">Bundle</td>
        <td className="col-sm-1 bundles-header-cell">ITaaS</td>
        <td className="col-sm-4 bundles-header-cell">A La Carte</td>
        <td className="col-sm-2 bundles-header-cell" aria-hidden="true"></td>
      </>
    );
  };

  return (
    <div>
      <Card className={"header-card " + (props.isLastList ? "" : "pb-2")}>
        <Accordion.Item
          id="accordionButton"
          eventKey={props.isHomeOffice ? props.list.companyNumber : props.businessUnit}
          className="base-accordion"
        >
          <Accordion.Header as={Card.Header} className="p-0 rounded">
            <RowCard
              mode="stats"
              data={[
                {
                  label: "Business Unit",
                  value: props.isHomeOffice ? props.list.businessUnitName : props.businessUnit,
                },
                { label: "Users", value: filteredUserBundleLicensesByCompanyList.length },
                { label: "ITaaS Users", value: getNumberOfItaasUsers() },
                { label: "Bundle Price", value: formatCurrency(getTotalPriceOfBundles()) },
                { label: "ITaaS Price", value: formatCurrency(getTotalPriceOfItaas()) },
                { label: "A La Carte Price", value: formatCurrency(getTotalPriceOfALaCarte()) },
              ]}
              padding="4px"
              compact
            />
          </Accordion.Header>
          <Accordion.Collapse
            eventKey={props.isHomeOffice ? props.list.companyNumber : props.businessUnit}
            style={{ padding: "0px 20px 20px 20px" }}
          >
            <DynamicTable header={renderHeaderRow()} rows={tableColumns} />
          </Accordion.Collapse>
        </Accordion.Item>
      </Card>
    </div>
  );
};

export default BundlesList;
